<template>
    <v-card tile flat class="bar-chart-vcard">
        <template v-if="title">
            <span v-if="chartSize == 'large'" class="text-h6">{{ title }}</span>
            <span v-else-if="chartSize == 'small'" class="text-subtitle-2">{{ title }}</span>
            <span v-else class="text-subtitle-1">{{ title }}</span>
        </template>
        <div class="bar-chart-with-contrast" :class="chartSize">
            <div class="block-wrapper" :class="chartSize">
                <div class="block"
                    :class="[chartSize, color]"
                    :style="{zIndex: isContrastBarLonger ? 20 : 10, width: mainPercent }">
                </div>
                <div v-if="hasContrastData" 
                    class="block block-contrast"
                    :class="isContrastBarLonger ? chartSize + ' light-' + color : chartSize + ' ' + color"
                    :style="{zIndex: isContrastBarLonger ? 10 : 20, width: contrastPercent }">
                    <div class="vertical-line" :class="isContrastBarLonger ? chartSize + ' ' + color : chartSize"></div>          
                </div>
                <div class="block bar-label" :class="chartSize">
                    <span>{{ mainValue }}&nbsp;{{ unit }}</span>
                </div>
            </div>
            <div class="contrast-label" :class="chartSize">
                <div class="vertical-center">
                    <div v-if="chartSize == 'large'" class="text-body-1 font-weight-light" >{{ contrastPeriodDesc[contrastPeriodCode] }}</div>
                    <div v-else-if="chartSize == 'small'" class="text-body-2 font-weight-light">{{ contrastPeriodDesc[contrastPeriodCode] }}</div>
                    <div v-else class="text-subtitle-1 font-weight-light">{{ contrastPeriodDesc[contrastPeriodCode] }}</div>

                    <div v-if="chartSize == 'large'" class="text-h5 font-weight-bold">{{ contrastValue }}&nbsp;{{ unit }}</div>
                    <div v-else-if="chartSize == 'small'" class="text-body-2 font-weight-bold">{{ contrastValue }}&nbsp;{{ unit }}</div>
                    <div v-else class="text-subtitle-1 font-weight-bold">{{ contrastValue }}&nbsp;{{ unit }}</div>
                </div>
            </div>
        </div>
    </v-card>
</template>

<script>
    import $ from 'jquery'
    export default {
        name: 'BarWithContrast',
        props: {
            title: String,
            mainValue: [Number, String],
            contrastValue: [Number, String],
            unit: String,
            contrastPeriodCode: Number,
            chartSize: { type: String, default: '' },
            color: { type: String, default: 'green' },
            relativeValue: [Number, String]
        },
        mounted: function() {
        },
        watch: {
        },    
        computed: {
            derivedRelativeValue: function() {
                if (!this.relativeValue) {
                    return Math.max(this.mainValue, this.contrastValue)
                } else {
                    return this.relativeValue
                }
            },
            mainPercent: function() {
                if (this.derivedRelativeValue == 0 || this.mainValue == 0) {
                    return '0%'
                } else {
                    return Math.floor(this.mainValue / this.derivedRelativeValue * 100) + '%';
                }
            },
            contrastPercent: function() {
                if (this.derivedRelativeValue == 0 || this.contrastValue == 0) {
                    return '0%'
                } else {
                    return Math.floor(this.contrastValue / this.derivedRelativeValue * 100) + '%';
                }
            },
            hasContrastData: function() {
                return (this.derivedRelativeValue > 0 && this.contrastValue > 0)
            },
            isContrastBarLonger: function() {
                return parseInt(this.contrastValue) > parseInt(this.mainValue);
            },
        },

        methods: {
        },

        data: () => ({
            contrastPeriodDesc: {
                5: 'Last 5 mins',
                60: 'Last 60 mins',
                180: 'Last 3 hrs',
                360: 'Last 6 hrs',
                720: 'Last 12 hrs',
                1440: 'Last 24 hrs',
                4320: 'Last 3 days',
                10080: 'Last 7 days',
                20160: 'Last 14 days',
                43200: 'Last 30 days'
            }
        }),
    }
</script>

<style scoped lang="scss">

    $bar-height-small: 24px;
    $bar-height-medium: 48px;
    $bar-height-large: 75px;

    $value-font-size-small: 14px;
    $value-font-size-medium: 20px;
    $value-font-size-large: 40px;


    .bar-chart-vcard {
        background-color: transparent !important;
    }

    .bar-chart-with-contrast {
        width: 100%;
        height: $bar-height-medium;
    }

    .bar-chart-with-contrast.small { height: $bar-height-small; }
    .bar-chart-with-contrast.large { height: $bar-height-large; }

    .block-wrapper {
        position: relative;
        float: left;
        width: 65%;
        height: $bar-height-medium;
    }

    .block-wrapper.small { height: $bar-height-small; }
    .block-wrapper.large { height: $bar-height-large; }

    .block {
        width: 100%;
        height: $bar-height-medium;;
        color: #fff;
        font-size: .75em;
        position: absolute;
        opacity: 1;
        transition: opacity, .3s ease;
        cursor: pointer;
        border-bottom-left-radius: 4px;
        border-top-left-radius: 4px;  
        border-bottom-right-radius: 4px;
        border-top-right-radius: 4px;    
    }

    .block.small { height: $bar-height-small; }
    .block.large { height: $bar-height-large; }

    .block.green { background-color: #4CAF50 !important; }
    .block.orange { background-color: #FF9800 !important; }
    .block.red { background-color: #F44336 !important; }
    .block.blue { background-color: #2196F3 !important; }
    .block.purple { background-color: #9C27B0 !important; }
    .block.indigo { background-color: #3F51B5 !important;}

    .block.block-contrast.light-green { background-color: #A5D6A7 !important; }
    .block.block-contrast.light-orange { background-color: #FFE0B2 !important; }
    .block.block-contrast.light-red { background-color: #FFCDD2 !important; }
    .block.block-contrast.light-blue { background-color: #BBDEFB !important; }
    .block.block-contrast.light-purple { background-color: #E1BEE7 !important; }
    .block.block-contrast.light-indigo { background-color: #C5CAE9 !important; }

    .block.block-contrast:before {
        content: "";
        position: absolute;
        bottom: -16px;
        right: 2px;
        transform:translate(50%,-50%);
        width: 14px;
        height: 14px;
        border-radius: 50%;
        border: 2px solid white;
        z-index: 40;
    }

    .block.block-contrast.small:before {
        bottom: -14px;
        width: 14px;
        height: 14px;
        border: 3px solid white;
    }

    .block.block-contrast.large:before {
        bottom: -20px;
        width: 20px;
        height: 20px;
        border: 3px solid white;
    }

    .block.block-contrast.light-green:before { background-color: #4CAF50; }
    .block.block-contrast.light-orange:before { background-color: #FF9800; }
    .block.block-contrast.light-red:before { background-color: #F44336; }
    .block.block-contrast.light-blue:before { background-color: #2196F3; }
    .block.block-contrast.light-purple:before { background-color: #9C27B0; }
    .block.block-contrast.light-indigo:before { background-color: #3F51B5; }

    .block.block-contrast.green:before { background-color: #4CAF50; }
    .block.block-contrast.orange:before { background-color: #FF9800; }
    .block.block-contrast.red:before { background-color: #F44336; }
    .block.block-contrast.blue:before { background-color: #2196F3; }
    .block.block-contrast.purple:before { background-color: #9C27B0; }
    .block.block-contrast.indigo:before { background-color: #3F51B5; }

    .block.bar-label {
        position: relative;
        z-index: 50;
        font-size: $value-font-size-medium;
        font-weight: bold;
    }
    .block.bar-label.small { font-size: $value-font-size-small; }
    .block.bar-label.large { font-size: $value-font-size-large; }
    
    .block.bar-label span {
        position: absolute;
        left: 8px;
        bottom: 8px;
    }
    .block.bar-label.large span {
        bottom: 6px;
    }
    .block.bar-label.small span {
        bottom: 0px;
    }

    .vertical-line {
        background-color: white !important;
        border-color: white !important;
        width: 3px;
        height: $bar-height-medium;
        position: absolute;
        top: 0px;
        right: 0px;
        z-index: 30;
    }

    .vertical-line.small { height: $bar-height-small; }
    .vertical-line.large { height: $bar-height-large; }

    .contrast-label {
        padding-left: 12px;
        float: left;
        width: 35%;
        height: $bar-height-medium;
        position: relative;        
    }

    .contrast-label.small { height: $bar-height-small; }
    .contrast-label.large { height: $bar-height-large; }

    .contrast-label .text-subtitle-1  { line-height: 1.35em; }
    .contrast-label.small .text-subtitle-2  { line-height: 1.15em; }

    .vertical-center {
        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }



</style>